import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ErrorSummaryService } from '../../services/error-summary.service';
import { CardErrorSummary, ErrorsSummary, EventCardErrorSummary, HeaderErrorSummary } from '../../../../../../utils/models/common.interface';
import { MatAccordion } from '@angular/material/expansion';

@Component({
  selector: 'error-summary-induxtry',
  templateUrl: './error-summary.component.html',
  styleUrls: ['./error-summary.component.scss']
})
export class ErrorSummaryComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild(MatAccordion) accordion: MatAccordion;

  @Input() active = false;
  @Input() showContent = false;
  @Input() header: HeaderErrorSummary;
  @Input() keyNowExpanded = '';
  @Input() errors: ErrorsSummary[];

  @Output() clickedCard: EventEmitter<EventCardErrorSummary> = new EventEmitter();
  @Output() clickedAccordion: EventEmitter<ErrorsSummary> = new EventEmitter();

  resizeEventListenerErrorSummary: () => void;

  constructor(
    private readonly errorSummaryService: ErrorSummaryService
  ) { }

  ngOnInit(): void {
    this.errorSummaryService.closeAllErrorSummary.subscribe(res => {
      this.accordion.closeAll();
    })

    this.updateAccordionsHeight();
    this.resizeEventListenerErrorSummary = () => {
      this.updateAccordionsHeight();
    };
    window.addEventListener("resize", this.resizeEventListenerErrorSummary);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.active && !changes.active.firstChange && changes.active.currentValue) {
      this.updateAccordionsHeight();
    }
  }

  updateAccordionsHeight(): void {
    setTimeout(() => {
      const header_errors = document.getElementById('js_header_error_summary'),
            accordions_errors = document.getElementById('js_accodions_error_summary'),
            container_errors = document.getElementById('js_container_error_summary');
      if (header_errors && accordions_errors && container_errors) {
        accordions_errors.style.height = `${container_errors.clientHeight - header_errors.clientHeight}px`;
      }
    }, 100);
  }

  handleOpenExpansionPainel(error: ErrorsSummary): void {
    this.keyNowExpanded = error.key;
    this.clickedAccordion.emit(error);
  }

  handleClosedExpansionPainel(error: ErrorsSummary): void {
    if (error.key === this.keyNowExpanded) {
      this.keyNowExpanded = '';
      this.clickedAccordion.emit(null);
    }
  }

  handleClickedCard(event: CardErrorSummary, key: string): void {
    this.clickedCard.emit({
      key: key,
      card: event
    });
  }

  handleClickClose(): void {
    this.errorSummaryService.handleChangeActiveErrorSummary(false);
  }

  ngOnDestroy(): void {
    window.removeEventListener("resize", this.resizeEventListenerErrorSummary);
  }
}
